// 站内信类型
// 系统通知
export const MESSAGE_ANNOUNCEMENT_TYPE = 0;
// 福利活动
export const MESSAGE_WELFARE_ACTS_TYPE = 1;
// 业务招募
export const MESSAGE_BUSINESS_RECRUIT_TYPE = 2;
// 设备动态
export const MESSAGE_DEVICE_MONITOR_TYPE = 3;

export const MESSAGE_TYPE_OPTIONS = [
  {
    label: '系统通知',
    value: MESSAGE_ANNOUNCEMENT_TYPE,
    name: 'publicMsgUnreadCount',
  },
  {
    label: '福利活动',
    value: MESSAGE_WELFARE_ACTS_TYPE,
    name: 'welfareMsgUnreadCount',
  },
  {
    label: '业务招募',
    value: MESSAGE_BUSINESS_RECRUIT_TYPE,
    name: 'recruitMsgUnreadCount',
  },
  {
    label: '设备动态',
    value: MESSAGE_DEVICE_MONITOR_TYPE,
    name: 'monitorMsgUnreadCount',
  },
];

export const MESSAGE_TYPE_MAP = {
  [MESSAGE_ANNOUNCEMENT_TYPE]: '系统通知',
  [MESSAGE_WELFARE_ACTS_TYPE]: '福利活动',
  [MESSAGE_BUSINESS_RECRUIT_TYPE]: '业务招募',
  [MESSAGE_DEVICE_MONITOR_TYPE]: '设备动态',
};

export const MESSAGE_TYPE_KEY_MAP = {
  [MESSAGE_ANNOUNCEMENT_TYPE]: 'public',
  [MESSAGE_WELFARE_ACTS_TYPE]: 'welfare',
  [MESSAGE_BUSINESS_RECRUIT_TYPE]: 'recruit',
  [MESSAGE_DEVICE_MONITOR_TYPE]: 'monitor',
};

// 封面类型
// 图文
export const COVER_WITH_IMAGE_TYPE = 0;
// 文字
export const COVER_ONLY_TEXT_TYPE = 1;

// 内容详情
// 跳转链接
export const CONTENT_LINK_TYPE = 0;
// 站内文章
export const CONTENT_ARTICLE_TYPE = 1;

export const PAGE_MODULE = 'message';

export const PAGE_SIZE = 30;
